module.exports = __webpack_public_path__ + "static/img/1.ab055e1.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/goods/xiaoshuo/1.png
// module id = UUQX
// module chunks = 1